"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const StyledInput = exports.StyledInput = _styled.default.input(_ref => {
  let {
    theme,
    ...rest
  } = _ref;
  return {
    background: 'transparent',
    border: '0',
    color: theme.colors.inputText,
    display: 'flex',
    flex: '1 1 0%',
    fontSize: theme.fontSizes.normal,
    fontWeight: theme.fontWeights.regular,
    outline: '0',
    paddingLeft: '16px',
    paddingRight: '16px',
    position: 'relative',
    width: '100%',
    '&::placeholder': {
      color: theme.colors.grey[500],
      fontWeight: theme.fontWeights.regular
    },
    '&:not(:focus)::placeholder': {
      opacity: 0
    },
    '&:focus::placeholder': {
      opacity: 1
    },
    '&:autofill': {
      paddingTop: '25px',
      '& + label': {
        // The <label> sibling of this <input>
        transform: 'scale(0.85) translateY(-130%)',
        transformOrigin: rest.direction === 'ltr' ? 'left' : 'right',
        transition: 'transform 0.2s ease-out'
      }
    }
  };
});